import '../../../styles/pages.css'

import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import { getAPIRequest } from 'infrastructure/api'
import { AssignmentAttempt } from 'infrastructure/api'
import { useUrlSearchParam } from 'shared/hooks/useSearchParams'

export function AssignmentAttemptList() {
  const [error, setError] = useState<string | null>(null)
  const [assignmentIDParam, setAssignmentIDParam] = useUrlSearchParam('id')
  const [data, setData] = useState<AssignmentAttempt[] | null>(null)

  const fetchAssignmentAttempts = async (id: string | number) => {
    setError(null)

    try {
      const res = await getAPIRequest<AssignmentAttempt[]>(
        `/v1/kat/assignment/${id}/attempts`,
      )
      if (res) {
        setData(res)
      } else {
        setError((res as any).error || 'Error fetching assignments')
        setData([])
      }
    } catch (e: any) {
      setError(e?.message || 'Error fetching assignments')
      setData(null)
    }
  }

  React.useEffect(() => {
    if (assignmentIDParam && assignmentIDParam.trim() !== '') {
      setAssignmentIDParam(assignmentIDParam.trim())
      fetchAssignmentAttempts(assignmentIDParam)
    }
  }, [assignmentIDParam])

  // Table columns for attempts
  const columns = [
    {
      title: <strong>Attempt ID</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => a.ID,
    },
    {
      title: <strong>Assignment ID</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => a.AssignmentID,
    },
    {
      title: <strong>Score</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => a.Score,
    },
    {
      title: <strong>Scored At</strong>,
      width: 150,
      rowContent: (a: AssignmentAttempt) => (a.scored_at ? a.scored_at : 'N/A'),
    },
    {
      title: <strong>Graded</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => (a.IsGraded ? 'Yes' : 'No'),
    },
    {
      title: <strong>Graded At</strong>,
      width: 150,
      rowContent: (a: AssignmentAttempt) => (a.GradedAt ? a.GradedAt : 'N/A'),
    },
    {
      title: <strong>Graded By</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => a.FirstGradedByLUserID,
    },
    {
      title: <strong>Submitted</strong>,
      width: 80,
      rowContent: (a: AssignmentAttempt) => (a.IsSubmitted ? 'Yes' : 'No'),
    },
    {
      title: <strong>Submitted At</strong>,
      width: 150,
      rowContent: (a: AssignmentAttempt) =>
        a.SubmittedAt ? a.SubmittedAt : 'N/A',
    },
    {
      title: <strong>Ingestion ID</strong>,
      width: 100,
      rowContent: (a: AssignmentAttempt) =>
        a.ingestion_id ? a.ingestion_id : 'N/A',
    },
    {
      title: <strong>Attempt SIS ID</strong>,
      width: 160,
      rowContent: (a: AssignmentAttempt) =>
        a.attempt_sis_id ? a.attempt_sis_id : 'N/A',
    },
  ]

  return (
    <div className="content-color">
      <div className="section-buttons">
        <p>
          <b>Assignment Attempts</b>
        </p>

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
      </div>
      <div>
        {data && data.length > 0 ? (
          <Box>
            <Table title={null} columns={columns} items={data} />
          </Box>
        ) : (
          <p>Assignment has no attempts</p>
        )}
      </div>
    </div>
  )
}
